import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';

const SuccessString = ({ 
    text, 
    onAction, 
    t 
}) => {
    const [state, setState] = useState({
        text: text || '',
        type: text ? 'text' : 'code'
    });

    const onChangeField = useCallback((event) => {
        const name = event.target.name;
        const value = event.target.value;

        setState(prevState => {
            const newState = {
                ...prevState,
                [name]: value
            };

            if (onAction) {
                const nextValue = newState.type === 'text' ? newState.text : '';
                onAction(nextValue);
            }

            return newState;
        });
    }, [onAction]);

    const staticNames = t?.postbackPage?.creatingEditing || {};

    return (
        <React.Fragment>
            <label className="checkbox-inline option">
                <input
                    className="option__input"
                    type="radio"
                    name={'type'}
                    checked={state.type === 'code'}
                    value={'code'}
                    onChange={onChangeField}
                />
                <span className="option__mark" />
                <span className="option__caption">{staticNames.code}</span>
            </label>
            <label className="checkbox-inline option">
                <input
                    className="option__input"
                    type="radio"
                    name={'type'}
                    checked={state.type === 'text'}
                    value={'text'}
                    onChange={onChangeField}
                />
                <span className="option__mark" />
                <span className="option__caption">{staticNames.codeText}</span>
                {state.type === 'text'
                ? (
                    <label className="checkbox-inline option text">
                        <input
                            className="form-control input-sm"
                            type="text"
                            name="text"
                            value={state.text}
                            onChange={onChangeField}
                            placeholder={staticNames.enterText}
                        />
                    </label>
                )
                : null
            }
            </label>
        </React.Fragment>
    );
};

SuccessString.propTypes = {
    text: PropTypes.string,
    onAction: PropTypes.func,
    t: PropTypes.object
};

SuccessString.defaultProps = {
    text: '',
    onAction: () => {},
    t: {}
};

export default withTranslation(SuccessString);